(ns ui.view.entity-graph.view
  (:require [ui.view.entity-graph.model :as m]
            [ui.view.entity-graph.node :as node]
            [ui.view.entity-graph.edge :as edge]
            [ui.view.entity-graph.auto-layout :as auto-layout]
            [ui.view.entity-graph.components.modal :as modal]
            [ui.view.entity-graph.components.sidebar :as sidebar]
            [ui.view.entity-graph.components.toolbar :as toolbar]
            [ui.view.entity-graph.components.node :as node-components]
            [ui.view.entity-graph.components.edge :as edge-components]
            [ui.util :as uu]
            [common.schema.entity-types :as entity-types]
            [frontend.intercom :as intercom]
            [frontend.routing :as routing]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.state.current-session :as session]
            [ui.view.entity-graph.sub]
            [ui.view.entity-graph.event]
            [frontend.view.not-found :as not-found]
            [re-frame.core :as rf]
            [reagent-flow.core :as flow]
            [reagent.core :as r]))

(defn allowed?
  [entity-id]
  (let [feature? (session/entity-graph?)
        entity @(r/track session/get-entity entity-id)
        entity-type (:entity/type entity)]
    (and feature?
         ;; must not be nil
         (some? entity)
         ;; nor disabled
         (not (:common/disabled? entity))
         (contains? entity-types/graph-for-entity-types entity-type))))

(defn initialize
  [ctx provider]
  (auto-layout/init ctx)
  (js/setTimeout
   #(rf/dispatch [m/flow-initialized
                  (-> ctx
                      (assoc
                       :provider provider
                       :map-profiles @(rf/subscribe [m/visible-map-profiles ctx])
                       :connectors @(rf/subscribe [m/visible-connectors ctx])))])
   100))

;; changing source/target-handle locations by dragging
(defn start-reconnect
  [ctx _e js-edge handle-type]
  (let [edge (js->clj js-edge :keywordize-keys true)
        connector-id (-> edge
                         :id
                         parse-long)]
    (rf/dispatch-sync [m/start-reconnect (assoc ctx
                                                :connector-id connector-id
                                                :handle-type handle-type)])))

(defn end-reconnect
  [ctx _e js-edge _handle-type _js-connection-state]
  (let [edge (js->clj js-edge :keywordize-keys true)
        connector-id (-> edge
                         :id
                         parse-long)]
    (rf/dispatch-sync [m/end-reconnect
                       (assoc ctx :connector-id connector-id)])))

(defn reconnect
  [ctx js-old-edge js-new-connection]
  (let [edge (js->clj js-old-edge :keywordize-keys true)
        connector-id (-> edge
                         :id
                         parse-long)
        new-connection (js->clj js-new-connection :keywordize-keys true)
        update {:target-handle (:targetHandle new-connection)
                :source-handle (:sourceHandle new-connection)}]
    (rf/dispatch-sync [m/apply-reconnect
                       (assoc ctx
                              :connector-id connector-id
                              :update update)])))

(defn close-ctx-menus
  [ctx]
  (rf/dispatch [m/close-node-menu ctx])
  (rf/dispatch [m/close-edge-menu ctx]))

(defn chart
  [{:keys [main-entity-id] :as ctx}]
  (r/with-let [init (partial initialize ctx)
               ref (atom nil)
               _ (rf/dispatch-sync
                  [m/init-state ctx])
               _ (intercom/hide)
        ;;TODO to edge-namespace?
               start-reconnect (partial start-reconnect ctx)
               end-reconnect (partial end-reconnect ctx)
               reconnect (partial reconnect ctx)
               node-changes (partial node/handle-changes ctx)
               edge-changes (partial edge/handle-changes ctx)]
    (let [;; TODO user-configurable:
          figma-controls? false
          pan-on-scroll (if figma-controls?
                          true
                          false)
          pan-on-drag (if figma-controls?
                        [1 2]
                        true)
          selection-on-drag (if figma-controls?
                              true
                              false)
          sidebar-collapsed? @(rf/subscribe [m/sidebar-collapsed? ctx])]
      [:div
       {:class-name (uu/cm "flex grow my-2_ _ml-2 select-none"
                           "py-2 pl-2")}
       [:div
        {:class (uu/cm "flex-1 border border-solid border-base-light-border-paler rounded-lg")}
        [modal/modals ctx]
        [:div
           ;; Note: width and height must be set for the flow/reagent-flow's container:
         {:id (str "graph-" main-entity-id)
          :class (uu/cm "h-full w-full")}
         [flow/reagent-flow
          {:id (str "flow-" main-entity-id)
           :ref (fn [r]
                  (when r
                    (reset! ref r)))
           :nodes @(rf/subscribe [m/flow-nodes ctx])
           :edges @(rf/subscribe [m/flow-edges ctx])
             ;;:snap-to-grid true
           :min-zoom 0.1
           :max-zoom 3
           :fit-view true
           :pan-on-scroll pan-on-scroll
           :pan-on-drag pan-on-drag
           :selection-on-drag selection-on-drag
           :delete-key-code ["Backspace" "Delete"]
           :on-nodes-change node-changes
           :on-edges-change edge-changes
           :on-reconnect reconnect
           :on-reconnect-start start-reconnect
           :on-reconnect-end end-reconnect
           :on-node-context-menu
           (fn [e a]
               ;;(js/console.log e)
             (.preventDefault ^js e)
             (let [;; possible to calculate closest source-handle:
                     ;;target (.-target e)
                   map-profile-id (-> a
                                      (unchecked-get "data")
                                      (unchecked-get "map-profile-id"))
                   client-x (.-clientX e)
                   client-y (.-clientY e)
                   rect (.getBoundingClientRect @ref)
                   b-x (.-x rect)
                   b-y (.-y rect)
                   x (- client-x b-x)
                   y (- client-y b-y)]
               (rf/dispatch [m/open-node-menu
                             (assoc ctx
                                    :left x :top y
                                    :map-profile-id map-profile-id)])))
           :on-edge-context-menu
           (fn [e a]
             (.preventDefault ^js e)
             (let [connector-id (-> a
                                    (unchecked-get "data")
                                    (unchecked-get "connectorId"))
                   client-x (.-clientX e)
                   client-y (.-clientY e)
                   rect (.getBoundingClientRect @ref)
                   b-x (.-x rect)
                   b-y (.-y rect)
                   x (- client-x b-x)
                   y (- client-y b-y)]
               (rf/dispatch [m/open-edge-menu
                             (assoc ctx
                                    :left x :top y
                                    :connector-id connector-id)])))
           :on-connect
           (fn [_args]
               ;;TODO open context menu to select connector-type
               ;; + percentage if applicable etc
             )
           :on-init init
           :on-pane-click (fn [_]
                            (rf/dispatch-sync [m/unselect-all ctx])
                            (close-ctx-menus ctx))
           :on-move (partial close-ctx-menus ctx)
           :on-pane-context-menu (partial close-ctx-menus ctx)
           :on-selection-drag (partial close-ctx-menus ctx)
           :on-selection-start (fn [_]
                                 (close-ctx-menus ctx)
                                 (rf/dispatch [m/start-selection ctx]))
           :on-selection-end (fn [_]
                               (rf/dispatch [m/end-selection ctx])
                               (when sidebar-collapsed?
                                 (rf/dispatch [m/set-sidebar-mode
                                               (assoc ctx :sidebar-mode :expanded)])))
           :on-node-click (fn [_]
                            (close-ctx-menus ctx))
           :on-selection-context-menu (partial close-ctx-menus ctx)
           :node-types ((fn [] node/types))
           :edge-types ((fn [] edge/types))
           :default-edge-options {:animated false
                                  :type :custom-edge
                                  :markerEnd
                                  {:type (.-ArrowClosed flow/FlowMarkerType)
                                   :width 20 :height 20
                                   :color "#FF0072"}}}
          [:div
           {:class "react-flow-controls"}
           [flow/controls]]
          ;; right-click action-menus:
          [node-components/context-menu ctx]
          [edge-components/context-menu ctx]
          [flow/background
           {:class (uu/cm "bg-secondary-light")
            :variant @(rf/subscribe
                       [m/background-variant ctx])}]]]]])
    (finally
      (intercom/show)
      (rf/dispatch [m/cleanup ctx]))))



(comment

  #_(->> common.schema.registry/static-cross-entity-schema
     (map second)
     (mapcat keys)
     set)

  :rcf)



(defn page-view
  [{:keys [_main-entity-id] :as ctx}]
  [:div
   {:class-name "entity-chart-main flex flex-col h-full overflow"}
   [:div
    {:class-name (uu/cm "px-2 md:px-4 py-1 border-b border-solid border-base-light-border-paler")}
    [toolbar/view ctx]]
   [:div
    ;; "h-full" needed?
    {:class-name "flex grow gap-2 max-h-full overflow-y-hidden"}
    [chart ctx]
    [sidebar/view
     ctx]]])

(defn page
  [entity-id]
  [default-page-layout/view
     ;;the key change forces re-rendering of the component (and its child components)
   ^{:key (str "chart-view-" entity-id)}
   [page-view {:main-entity-id entity-id}]])

(defmethod routing/render-view :entity-graph
  [{:keys [route-params]}]
  (let [entity-id (-> route-params
                      :id
                      parse-long)]
    (if-not (allowed? entity-id)
      [not-found/not-found-view]
      [page entity-id])))
